import React from 'react'
import Grid from '@mui/material/Grid'
import { IoMdCheckboxOutline } from 'react-icons/io'
import './BuildingAndProperty.scss'
import { objectHasAnyValue } from '../../../../../resources/Utils'

const Utilities = React.memo(({ utilitiesEntity }) => {
  const utilities = React.useMemo(() => utilitiesEntity, [utilitiesEntity])

  const hasHeatSource = React.useMemo(() => {
    const hasHeatSource = objectHasAnyValue(utilities.heatSource)

    return hasHeatSource
  }, [utilities.heatSource])

  return (
    <>
      {utilities &&
      ((utilities.electricalShutOffLocation && utilities.electricalShutOffLocation.shutOff) ||
        (utilities.automaticBackupGenerator && utilities.automaticBackupGenerator.isChecked) ||
        (utilities.waterShutOffLocation && utilities.waterShutOffLocation.shutOff) ||
        hasHeatSource) ? (
        <h2 className="section-title">Utilities</h2>
      ) : null}

      {utilities &&
      utilities.electricalShutOffLocation &&
      utilities.electricalShutOffLocation.shutOff &&
      utilities.electricalShutOffLocation.shutOff ? (
        <Grid className="section">
          <label className="main-title-label">
            Electrical shut off:{' '}
            {utilities.electricalShutOffLocation.shutOff === 1 ? (
              <span className="answer">
                Inside
                {utilities.electricalShutOffLocation.shutOff &&
                utilities.electricalShutOffLocation.shutOff === 1 &&
                utilities.electricalShutOffLocation.location &&
                utilities.electricalShutOffLocation.location ? (
                  <>{`, ${utilities.electricalShutOffLocation.location}`}</>
                ) : null}
              </span>
            ) : (
              ' Outside'
            )}
          </label>
        </Grid>
      ) : null}

      {utilities &&
      utilities.waterShutOffLocation &&
      utilities.waterShutOffLocation.shutOff &&
      utilities.waterShutOffLocation.shutOff ? (
        <Grid className="section">
          <label className="main-title-label">
            Water shut off:{' '}
            {utilities.waterShutOffLocation.shutOff === 1 ? (
              <span className="answer">
                Inside
                {utilities.waterShutOffLocation.shutOff &&
                utilities.waterShutOffLocation.location &&
                utilities.waterShutOffLocation.location ? (
                  <>{`, ${utilities.waterShutOffLocation.location}`}</>
                ) : null}
              </span>
            ) : (
              ' Outside'
            )}
          </label>
        </Grid>
      ) : null}
      {utilities &&
      utilities.heatSource &&
      utilities.heatSource !== undefined &&
      utilities.heatSource &&
      (utilities.heatSource.naturalGas ||
        utilities.heatSource.propane ||
        utilities.heatSource.other ||
        utilities.heatSource.propaneTankLocation ||
        utilities.heatSource.mainShutOffLocation) ? (
        <Grid className="section">
          <label className="main-title-label">Heat Source:</label>

          <Grid className="container-field">
            {utilities.heatSource.naturalGas && utilities.heatSource.naturalGas ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {utilities.heatSource.naturalGas ? ' Natural gas' : ''}
                </label>
              </Grid>
            ) : null}

            {utilities.heatSource.propane && utilities.heatSource.propane ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />}
                  {utilities.heatSource.propane ? ' Propane' : ''}
                  {utilities.heatSource.propane &&
                  utilities.heatSource.propaneTankLocation &&
                  utilities.heatSource.propaneTankLocation ? (
                    <>{`, ${utilities.heatSource.propaneTankLocation}`}</>
                  ) : null}
                </label>
              </Grid>
            ) : null}

            {utilities.heatSource.other && utilities.heatSource.other ? (
              <Grid>
                <label>
                  {<IoMdCheckboxOutline />} Other: {utilities.heatSource.other}
                </label>
              </Grid>
            ) : null}
          </Grid>
          {utilities.heatSource &&
          utilities.heatSource.mainShutOffLocation &&
          utilities.heatSource.mainShutOffLocation ? (
            <Grid className="section">
              {utilities.heatSource.mainShutOffLocation.shutOff &&
              utilities.heatSource.mainShutOffLocation.shutOff ? (
                <Grid>
                  <label className="main-title-label">
                    Main shut off:
                    {utilities.heatSource.mainShutOffLocation.shutOff === 1 ? (
                      <span className="answer">
                        {' '}
                        Inside
                        {utilities.heatSource.mainShutOffLocation.shutOff &&
                        utilities.heatSource.mainShutOffLocation.location ? (
                          <>{`, ${utilities.heatSource.mainShutOffLocation.location}`}</>
                        ) : null}
                      </span>
                    ) : (
                      <span className="answer"> Outtside</span>
                    )}
                  </label>
                </Grid>
              ) : null}
            </Grid>
          ) : null}
        </Grid>
      ) : null}

      {utilities &&
      utilities.automaticBackupGenerator &&
      utilities.automaticBackupGenerator.isChecked &&
      utilities.automaticBackupGenerator.isChecked ? (
        <Grid className="section">
          <label className="main-title-label">
            Automatic Backup Generator:
            {utilities.automaticBackupGenerator.isChecked ? (
              <span className="answer">
                {' '}
                Yes
                {utilities.automaticBackupGenerator.isChecked &&
                utilities.automaticBackupGenerator.location &&
                utilities.automaticBackupGenerator.location ? (
                  <>{`, ${utilities.automaticBackupGenerator.location}`}</>
                ) : null}
              </span>
            ) : (
              ''
            )}
          </label>
        </Grid>
      ) : null}
    </>
  )
})

export default Utilities
